var map = {
	"./A Thousand Years.mp3": "9074",
	"./Afgan feat Rossa - Kamu Yang Kutunggu.mp3": "5088",
	"./Aizat Amdan - Sampai Ke Hari Tua.mp3": "4b16",
	"./Ari Lasso feat Bunga Citra Lestari - Aku Dan Dirimu.mp3": "478d",
	"./Cant Help Falling In Love - Live Session (Desmond Amos ft. DA Entertainment).mp3": "dbbb",
	"./Cinta Luar Biasa - Andmesh Kamaleng (Saxophone Cover by Desmond Amos).mp3": "c718",
	"./Rossa - Terlalu Cinta (Saxophone Cover by Dori Wirawan).mp3": "0eca",
	"./Shane Filan-Beautiful In White.mp3": "d50c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8903";